import { render, staticRenderFns } from "./CrearSolicitud.vue?vue&type=template&id=75cde1d6&"
import script from "./CrearSolicitud.vue?vue&type=script&lang=ts&"
export * from "./CrearSolicitud.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('75cde1d6', component.options)
    } else {
      api.reload('75cde1d6', component.options)
    }
    module.hot.accept("./CrearSolicitud.vue?vue&type=template&id=75cde1d6&", function () {
      api.rerender('75cde1d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/SolicitudBajaCliente/Crear/CrearSolicitud.vue"
export default component.exports